module.exports = __webpack_public_path__ + "static/1-d536be478bd20f39149b3fdad09148c6.png";